/* eslint-disable no-nested-ternary */
export class ImportOptionsSummaryBuilder {
  constructor({ i18n }) {
    this.i18n = i18n;
  }

  generateEntityOptionsSummary(options) {
    let summaryText = '';
    const newText = this.i18n.get('Import_ImportOptions_Summary_New');
    const existingText = this.i18n.get('Import_ImportOptions_Summary_Existing');
    const isImportingNewItems = options.ImportNewEntities;
    const isImportingExistingItems = options.ImportUpdatedEntities;

    if (isImportingNewItems || isImportingExistingItems) {
      if (isImportingNewItems && isImportingExistingItems) {
        summaryText = `${newText} & ${existingText.toLowerCase()}`;
      } else if (isImportingNewItems) {
        summaryText = newText;
      } else {
        summaryText = existingText;
      }

      summaryText += ` ${this.i18n.get('Import_ImportOptions_Summary_Items')}`;
    }

    return summaryText;
  }

  generateMonetaryOptionsSummary(options) {
    let summaryText = '';
    const bidText = this.i18n.get('Import_ImportOptions_Summary_Bids');
    const budgetText = this.i18n.get('Import_ImportOptions_Summary_Budgets');
    const isAdjustingBid = options.SetLowerBidsToAdCenterMinBids;
    const isAdjustingBudget = options.SetLowerCampaignBudgetsToAdCenterMinCampaignBudgets;

    if (isAdjustingBid && isAdjustingBudget) {
      summaryText = `${bidText} & ${budgetText.toLowerCase()}`;
    } else if (isAdjustingBid) {
      summaryText = bidText;
    } else if (isAdjustingBudget) {
      summaryText = budgetText;
    }

    return summaryText;
  }

  generateOtherOptionsSummary(options) {
    const summaryText = [];

    if (options.PrefixAndSuffixForUrls.EnablePrefixAndSuffix ||
      options.SearchAndReplaceForUrls.EnableSearchAndReplace) {
      summaryText.push(this.i18n.get('Import_ImportOptions_Summary_AdUrls'));
    }

    if (options.PrefixAndSuffixForTrackingTemplates.EnablePrefixAndSuffix ||
      options.SearchAndReplaceForTrackingTemplates.EnableSearchAndReplace) {
      summaryText.push(this.i18n.get('Import_ImportOptions_Summary_TrackingTemplate'));
    }

    return summaryText.join(', ');
  }

  generateSummaryFromSelectedOptions(options) {
    const summaryText = [];

    const entityOptionsText =
      this.generateEntityOptionsSummary(options);
    const bidOptionsText =
      this.generateMonetaryOptionsSummary(options);
    const otherOptionsText =
      this.generateOtherOptionsSummary(options);

    if (entityOptionsText.length > 0) {
      summaryText.push(entityOptionsText);
    }

    if (bidOptionsText.length > 0) {
      summaryText.push(bidOptionsText);
    }

    if (otherOptionsText.length > 0) {
      summaryText.push(otherOptionsText);
    }

    return summaryText.join(', ');
  }

  generateFormattedOptionsSummary(options) {
    const MAX_LEN = 97;
    let summaryText = this.generateSummaryFromSelectedOptions(options);

    if (summaryText.length > 100) {
      summaryText = `${summaryText.substring(0, MAX_LEN)}...`;
    }

    return summaryText;
  }
}
